export default "<p>\n Wolkeplatz Cloud-Community\n</p>\n";